<div class="header">
    <h1>{{title}}</h1>
    <div class="spacer"></div>
    <ng-container *ngIf="isEditable">
        <btn *ngIf="!isEdit"
             type="actionMore"
             icon="fa-pen"
             (onClick)="edit()"></btn>
        <btn *ngIf="isEdit"
             type="actionPrincipal"
             icon="fa-check"
             (onClick)="edit()"></btn>
    </ng-container>
</div>
<div class="description" *ngIf="description">
    <label [innerHTML]="description"></label>
</div>
<div class="content">
    <table>
        <tr>
            <th class="firstRow">{{wording.name}}</th>
            <th class="rowFix">{{wording.type}}</th>
            <th class="LastRow">{{wording.dateOfBirth}}</th>
        </tr>
        <tr *ngFor="let traveller of travellers">
            <td class="firstRow" *ngIf="!isEdit && formValue && formValue[traveller.id]">
                {{formValue[traveller.id] | travellerIdentity}}
            </td>
            <td class="firstRowEdit" *ngIf="isEdit">
                <div class="flexDiv">
<!--                    {{formValue[traveller.id].title}}-->
                    <simple-select class="input"
                                   [fieldConfig]="config[traveller.id].titleConfig"
                                   [withBorder]="withBorder"
                                   (blur)="editTraveller()">
                    </simple-select>
                    <text class="input"
                          [fieldConfig]="config[traveller.id].lastNameConfig"
                          (onBlur)="editTraveller()"
                          (onKeyPress)="editTraveller()">
                    </text>
                    <text class="input"
                          [fieldConfig]="config[traveller.id].firstNameConfig"
                          (onBlur)="editTraveller()"
                          (onKeyPress)="editTraveller()">
                    </text>
                </div>
            </td>
            <td class="rowFix">
                {{formValue[traveller.id] | travellerType}}
            </td>
            <td class="LastRow" *ngIf="!isEdit && !formValue[traveller.id].birthDate"><label class="notDef">{{wording.undefined}}</label></td>
            <td class="LastRow" *ngIf="!isEdit && formValue[traveller.id].birthDate">{{formValue[traveller.id].birthDate | dateMoment: "DD/MM/YYYY"  }}</td>
            <td class="LastRow" *ngIf="isEdit">
                <date-field class="inputDate"
                            [fieldConfig]="config[traveller.id].birthDateConfig"
                            (onBlur)="editTraveller()"
                            (onSelect)="editTraveller()">

                </date-field>
            </td>
        </tr>
    </table>
</div>

